
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="px-16 py-6 flex items-center justify-between">
          <h1 className="text-2xl font-serif text-[#1a1f36] font-semibold">BRAZDA DOO</h1>
          <div className="flex items-center gap-10">
            <button onClick={() => scrollToSection('home')} className="text-[#1a1f36] hover:text-[#4a90e2] transition-colors text-sm font-light cursor-pointer whitespace-nowrap">Home</button>
            <button onClick={() => scrollToSection('about')} className="text-[#1a1f36] hover:text-[#4a90e2] transition-colors text-sm font-light cursor-pointer whitespace-nowrap">About</button>
            <button onClick={() => scrollToSection('products')} className="text-[#1a1f36] hover:text-[#4a90e2] transition-colors text-sm font-light cursor-pointer whitespace-nowrap">Products</button>
            <button onClick={() => scrollToSection('features')} className="text-[#1a1f36] hover:text-[#4a90e2] transition-colors text-sm font-light cursor-pointer whitespace-nowrap">Features</button>
            <button onClick={() => scrollToSection('contact')} className="text-[#1a1f36] hover:text-[#4a90e2] transition-colors text-sm font-light cursor-pointer whitespace-nowrap">Contact</button>
          </div>
        </div>
      </nav>

      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}
